import { CartType } from './common'
import { HistoryStatusObject } from './status'

export enum LogisticCartUrgency {
  medium = 'medium',
  high = 'high',
}

export enum LogisticCartStatus {
  waiting = 'waiting',
  error = 'error',
  denied = 'denied',
  in_process = 'in_process',
  given = 'given',
}

export interface LogisticCartSpecialist {
  pk: string
  phone: string
  full_name: string
}

export interface LogisticCart {
  id: number
  created_at: string
  date_embossment: string
  client_full_name: string
  pan: string
  phone: string
  cart_type: CartType
  degree_urgency: LogisticCartUrgency
  status: LogisticCartStatus
  comment?: string
  specialist?: LogisticCartSpecialist

  status_title?: string
  cart_type_title?: string
  degree_urgency_title?: string

  status_list?: Array<HistoryStatusObject>
}
